import * as React from 'react';
import { PageSection, Title } from '@patternfly/react-core';
import { Spinner } from '@patternfly/react-core';

const PageLoader: React.FC = () => {

    return (
        <PageSection>
          <Title headingLevel="h1" className="pf-u-mb-md">Loading</Title>
          <Spinner isSVG />
        </PageSection>
      );

};

export default PageLoader;